import React, { useEffect, useState } from 'react';
import { fetchConToken } from '../../api/fetch';
import { Card, Col, Row } from 'react-bootstrap';
import Table from '../Table';
import { headTbl } from '../../data/tables';
import { useContextInfo } from '../../context/ContextInfo';
import { useParams } from 'react-router-dom';

const TabLogs = () => {
    const { id } = useParams();
    const idR = atob(id);
    const { setResp } = useContextInfo();

    const [logs, setLogs] = useState([]);

    useEffect(() => {
        getInter();
    }, [idR]);
    const getInter = async () => {
        const res = await fetchConToken(`routeros/logs/${idR}`);
        if (res.ok) {
            const dt = res.data;
            setLogs(dt.reverse());
        } else {
            setResp(res);
        }
    };
    const columns = [
        {
            Header: 'Fecha',
            accessor: 'time',
            sort: true,
        },

        {
            Header: ' Tipo',
            accessor: 'topics',
            sort: true,
        },
        {
            Header: ' Log',
            accessor: 'message',
            sort: true,
        },
    ];
    const sizePerPageList = headTbl(logs.length);

    return (
        <Row>
            <Col>
                <Card>
                    <Card.Body>
                        <Table
                            columns={columns}
                            data={logs}
                            pageSize={25}
                            sizePerPageList={sizePerPageList}
                            isSortable={true}
                            pagination={true}
                            isSearchable={true}
                        />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default TabLogs;
